module.exports = __webpack_public_path__ + "static/media/jp_logo_mobile.8b485689.png";